import { useState, useEffect } from 'react';

interface ABTestConfig {
  testId: string;
}

interface ABTestResult {
  variant: 'A' | 'B';
  trackConversion: (additionalData?: Record<string, any>) => void;
}

export const useABTest = (testId: string): ABTestResult => {
  const [variant, setVariant] = useState<'A' | 'B'>('A');

  useEffect(() => {
    const storageKey = `ab_test_${testId}`;
    const stored = localStorage.getItem(storageKey);

    if (stored === 'A' || stored === 'B') {
      setVariant(stored);
    } else {
      const randomVariant = Math.random() < 0.5 ? 'A' : 'B';
      setVariant(randomVariant);
      localStorage.setItem(storageKey, randomVariant);
    }

    // Track impression
    const impressionKey = `ab_impression_${testId}_${stored || 'new'}`;
    const impressionCount = parseInt(localStorage.getItem(impressionKey) || '0', 10);
    localStorage.setItem(impressionKey, String(impressionCount + 1));
  }, [testId]);

  const trackConversion = (additionalData?: Record<string, any>) => {
    const conversionData = {
      test_id: testId,
      variant,
      timestamp: new Date().toISOString(),
      page: window.location.pathname,
      ...additionalData,
    };

    // Store conversion data for form submission
    sessionStorage.setItem('ab_conversion_data', JSON.stringify(conversionData));

    // Track conversion count locally
    const conversionKey = `ab_conversion_${testId}_${variant}`;
    const conversionCount = parseInt(localStorage.getItem(conversionKey) || '0', 10);
    localStorage.setItem(conversionKey, String(conversionCount + 1));
  };

  return { variant, trackConversion };
};